// extracted by mini-css-extract-plugin
export var aiStarIcon = "_sv-2";
export var container = "_sv-4";
export var dismissButton = "_sv-3";
export var hasPaddingBottom = "_sv-6";
export var last = "_sv-e";
export var scrollbarThumb = "_sv-c";
export var scrollbarTrack = "_sv-b";
export var selected = "_sv-9";
export var spin = "_sv-1";
export var spinning = "_sv-0";
export var suggestionItem = "_sv-d";
export var suggestionsPanel = "_sv-5";
export var tonePill = "_sv-8";
export var tonesContainer = "_sv-7";
export var unselected = "_sv-a";